import React from "react";
import { useState, useEffect } from "react";
import SchoolAdminDashboard from "./schoolAdminDashboard";
import Snackbar from "@material-ui/core/Snackbar";
import "./schoolAdmin.css";
import Card from "react-bootstrap/Card";
import ReactPlayer from "react-player";
import moment from "moment";
import { Modal } from "react-bootstrap";
import greySearch from "../../assets/images/greySearch.png";
import close from "../../assets/images/whitecross.png";
//MUI
import FilterListIcon from "@material-ui/icons/FilterList";
import Dialog from "@material-ui/core/Dialog";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import { Link } from "react-router-dom";
//ASSETS
import crosstick from "../../assets/images/crosstick.png";
import schoolHighlights from "../schoolAdminPortal/images/schoolHighlights.png";
import threedotIMG from "../schoolAdminPortal/images/threedotIMG.png";
import sndHighlite from "../../assets/images/sndHighlite.svg";
import Delete from "../../assets/images/Delete.png";
import successimg from "../../assets/images/successimg.png";
import userService from "../../services/user.service";
import {
  getFromLocalStorage,
  setInToLocalStorage,
} from "../../utils/webStorage";
import { BsXLg } from "react-icons/bs";
//
function SchoolHighlights() {
  //Share pop up
  const [deleteId, setDeleteId] = useState(null);
  const [opens, setOpen] = useState(false);
  const [schoolId, setSchoolId] = useState(null);

  const [getAllHighlight, setGetAllHighlight] = React.useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [popSuccess, setSuccessPopDelete] = useState(false);
  const [highlightId, setHighlightId] = useState(null);
  const [adminRole, setadminRole] = useState(null);
  var [countCheck, setCountCheck] = useState(null);

  useEffect(() => {
    var schoolId = getFromLocalStorage("schoolId");
    var adminRole = getFromLocalStorage("loginRole");
    setadminRole(adminRole);
    setSchoolId(schoolId);
    setSubmitting(true);
    userService
      .getAllHighlightsForSchool(schoolId)
      .then((response) => {
        setGetAllHighlight(response.data.data.highlightDetailsResponse);
        setSubmitting(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setSubmitting(false);
      });
    getAllCoachesData(schoolId);
    getAllAtheleteData(schoolId);
  }, []);

  const searchItems = (searchValue) => {
    setSearchInput(searchValue);
    // debugger
    // var test= searchValue

    if (searchValue.length > 1) {
      userService.highlighteSearch(searchValue).then((response) => {
        if (response.data.status == true) {
          setGetAllHighlight(response.data.data.highlightDetailsResponse);
          setSubmitting(false);
        }
      });
    } else {
      userService
        .getAllHighlightsForSchool(schoolId)
        .then((response) => {
          setGetAllHighlight(response.data.data.highlightDetailsResponse);
          setSubmitting(false);
        })
        .catch((error) => {
          console.error("There was an error!", error);
          setSubmitting(false);
        });
    }
  };

  const callAllHighlightGet = () => {
    userService
      .getAllHighlightsForSchool(schoolId)
      .then((response) => {
        setGetAllHighlight(response.data.data.highlightDetailsResponse);
        setSubmitting(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setSubmitting(false);
      });
  };

  const highlighsViewsCountApi = (id) => {
    // debugger
    if (countCheck != id) {
      var isViews = true;
      userService.highlighsViewsCount(id, isViews).then((response) => {
        callAllHighlightGet();
        var idView = id;
        countCheck = id;
      });
    }
  };

  const handleClickToOpen = () => {
    setOpen(true);
  };

  const handleToClose = () => {
    setOpen(false);
  };

  const openDialog = (id) => {
    setDeleteId(id);

    setOpen(true);
  };

  //
  //delete pop up
  //Share pop up
  const [opendel, setOpendel] = React.useState(false);

  const handleClickToDel = () => {
    setOpendel(true);
  };

  const handleToDel = () => {
    setOpendel(false);
  };

  //
  //DELETE SUCCES POP UP
  const [opendelSuccess, setOpendelSuccess] = React.useState(false);
  const [coachesDataTest, setCoachesDataTest] = React.useState([]);
  const [atheleteDataTest, setAtheleteDataTest] = React.useState([]);
  const [editedVideoPopUpShow, seteditEdVideoPopUpShow] = React.useState("");
  const [highlightIdSend, setHighlightId1] = React.useState("");
  const [showAtheleteModal, setShowAtheleteModal] = React.useState(false);
  const [showShareModal, setShowShareModal] = React.useState(false);
  const [showNameSelectFeed, setShowNameSelectFeed] =
    React.useState("Share on Feed");
  const [videoTitle, setVideoTitle] = React.useState("");
  const [videoDescription, setVideoDescription] = React.useState("");
  const [openDialogShare, setOpenDialogShare] = React.useState(false);
  const [showfive, setShowfive] = React.useState(false);
  const [coaches, setCoaches] = React.useState([]);
  const [athletes, setAthletes] = React.useState([]);
  const [eventMediaId, setEventMediaId] = React.useState("");
  const [shareOnId, setShareOnId] = React.useState("1");
  // const [schoolId,setSchoolId] = React.useState('');
  const [eventId, setEventId] = React.useState("");
  const [sendHighlightRequest, setSendHighlightRequest] = React.useState(false);
  const [openHighlightSuccess, setOpenHighlightSuccess] = React.useState(false);
  const [openDialogHighlightRequest, setOpenDialogHighlightRequest] =
    React.useState(false);

  const closeHighlightSuccessMsg = () => {
    setOpenHighlightSuccess(false);
  };

  const openHighlightSendRequest = (id) => {
    setSendHighlightRequest(true);
    setHighlightId1(id);
  };

  const closeHighlightSendRequest = () => {
    setSendHighlightRequest(false);
  };

  const openDialogShare1 = () => {
    setOpenDialogShare(true);
  };
  const closeDialogShare = () => {
    setOpenDialogShare(false);
  };

  const handleToDelSuccess = () => {
    setOpendelSuccess(true);
  };

  const handleCloseToDelSuccess = () => {
    setOpendelSuccess(false);
  };

  const handleModelone = () => {
    // this.setState({ showAtheleteModal: false });
    setShowAtheleteModal(false);
  };
  const handleModelAthelete = () => {
    // this.setState({ showAtheleteModal: !this.state.showsix });
    setShowAtheleteModal(true);
  };
  const handleModelfour = () => {
    // this.setState({ showShareModal: !this.state.showfour });
    // this.setState({ showAtheleteModal: !this.state.showsix });
    setShowfive(false);
    setShowShareModal(true);
    setShowAtheleteModal(false);
  };

  const onTypeOpen = () => {
    setShowfive(true);
  };

  const handleModelfive = () => {
    // this.setState({ showAtheleteModal: true });
    setShowfive(false);
    setShowAtheleteModal(false);
    setShowShareModal(false);
    // this.setState({ showShareModal: false });
  };

  const handleModelfive1 = () => {
    setShowfive(false);
  };

  const getAllCoachesData = (schoolId) => {
    userService
      .getAllCoachesDropdown(schoolId)
      .then((response) => {
        // var coachesDataTest = response.data.data;
        // this.setState({ coachesDataTest });
        setCoachesDataTest(response.data.data);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const getAllAtheleteData = (schoolId) => {
    userService
      .getAllAtheleteDropdown(schoolId)
      .then((response) => {
        // var atheleteDataTest = response.data.data;
        // this.setState({ atheleteDataTest });
        setAtheleteDataTest(response.data.data);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const closeDialog = () => {
    setOpen(false);
  };

  const ConfirmcloseDialog = () => {
    userService.deleteHighlight(deleteId).then((res) => {
      setOpen(false);
      callAfterDelete();
    });
  };

  const openDialogRemoved = () => {
    // this.setState({ openSuccessEvent: !this.state.openSuccessEvent });
    setSuccessPopDelete(true);
  };
  const closeDialogRemoved = () => {
    // this.setState({ openSuccessEvent: !this.state.openSuccessEvent });
    setSuccessPopDelete(false);
  };

  const coachesForFeed = (id, e, i) => {
    var checkFlag = e.target.checked;
    if (checkFlag) {
      coaches.push(id);
    } else {
      coaches.splice(i, 1);
    }
  };

  const athleteForFeed = (id, e, i) => {
    var checkFlag1 = e.target.checked;
    if (checkFlag1) {
      athletes.push(id);
    } else {
      athletes.splice(i, 1);
    }
  };

  const selectedShareVideo = (data, eventMediaIdPost) => {
    var editedVideoPopUpShow = data;
    seteditEdVideoPopUpShow(editedVideoPopUpShow);
    setHighlightId1(eventMediaIdPost);
    // this.setState({ editedVideoPopUpShow, eventId, eventMediaId });
    handleModelfour();
  };

  const selectedEdit = (url, highlightId) => {
    setInToLocalStorage("highlightedMergeVideoUrl", url);
    setInToLocalStorage("highlightId", highlightId);
  };

  const handleRadioChange = (event) => {
    if (event.target.value == 1) {
      var showNameSelectFeed = "Share on Feed";
      //  this.setState({ showNameSelectFeed });
      setShowNameSelectFeed(showNameSelectFeed);
    }
    if (event.target.value == 2) {
      var showNameSelectFeed = "Share to a groups";
      //  this.setState({ showNameSelectFeed });
      setShowNameSelectFeed(showNameSelectFeed);
    }
    if (event.target.value == 3) {
      var showNameSelectFeed = " Share to Athletes / Coaches";
      //  this.setState({ showNameSelectFeed });
      setShowNameSelectFeed(showNameSelectFeed);
      handleModelAthelete();
    }
    setShareOnId(event.target.value);
  };

  const test = (data) => {
    setVideoTitle(data);
  };

  const test1 = (data) => {
    setVideoDescription(data);
  };

  const callPostForFeed = () => {
    userService
      .postFeedMergeHighlight({
        eventId: eventId,
        eventMediaId: eventMediaId,
        shareOnId: shareOnId,
        videoDescription: videoDescription,
        videoTitle: videoTitle,
        schoolId: schoolId,
        athletes: athletes,
        coaches: coaches,
        highlightId: highlightIdSend,
      })
      .then((res) => {
        handleModelfour();
        setOpenDialogShare(true);
        // videoDescription = "";
        // videoTitle = "";
      });
  };

  const callHighlightSend = () => {
    var shareOnIdTosend = 4;
    userService
      .postFeedMergeHighlight({
        eventId: eventId,
        eventMediaId: eventMediaId,
        shareOnId: shareOnIdTosend,
        videoDescription: videoDescription,
        videoTitle: videoTitle,
        schoolId: schoolId,
        athletes: athletes,
        coaches: coaches,
        highlightId: highlightIdSend,
      })
      .then((res) => {
        closeHighlightSendRequest();
        setOpenHighlightSuccess(true);
        setOpenDialogHighlightRequest(true);
      });
  };

  const AppSharePopUp = () => (
    <ReactPlayer
      id="videoPlayer1"
      url={editedVideoPopUpShow}
      playing
      controls
      className="w-100 "
    />
  );

  const callAfterDelete = () => {
    userService
      .getAllHighlightsForSchool(schoolId)
      .then((response) => {
        setGetAllHighlight(response.data.data.highlightDetailsResponse);
        setSubmitting(false);
        openDialogRemoved();
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setSubmitting(false);
      });
  };

  const storeVideoIdHighlight = (id) => {
    var sendMediaIdHighlight = id;
    this.setState({ sendMediaIdHighlight });
    this.handleModelseven();
  };

  const handleModelseven = () => {
    // this.setState({ showseven: !showseven });
    //this.setState({ showsix: !this.state.showsix })
  };

  const closeDialogHighlightRequest = () => {
    setOpenDialogHighlightRequest(false);
  };

  //

  return (
    <div className={submitting ? "gray-out" : " "}>
      <SchoolAdminDashboard></SchoolAdminDashboard>

      <div className="content-heighlight padIn20">
        <div className="row">
          <div className="col-6 col-sm-5 col-md-4 col-lg-4 moboplr">
            <input
              type="text"
              className="input-style olnone search-icon w-100 searchHeighlight"
              placeholder="Search in highlights..."
              onChange={(e) => searchItems(e.target.value)}
            ></input>
          </div>
          {/* <div className="col-lg-1 text-center align-self">
            <FilterListIcon className="cp" onClick={handleClickToOpen} />
           
            <Dialog open={open} onClose={handleToClose} id="FilterHighlight">
              <DialogTitle>
                <div className="row">
                  <div className="col-10 col-lg-10 col-md-10">
                    <label className="fs-18 semibold">Filter: Coaches</label>
                  </div>
                  <div className="col-1 text-right ml-auto">
                    <img src={close}
                      onClick={handleToClose}
                      className="crossview cp"></img>
                  </div>
                </div>
              </DialogTitle>
              <hr className="mt-0 mb-0"></hr>
              <DialogContent>
                <DialogContentText>
                  I am Good, Hope the same for you!
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleToClose}
                  color="primary" autoFocus>
                  Close
                </Button>
              </DialogActions>
            </Dialog>
         
          </div> */}
          <div className="col-lg-8 col-6 text-right plr moboplr">
            {adminRole != "ATHLETE" && (
              <Button className="addBtn" startIcon={<AddIcon />}>
                <Link
                  to="/CreateHighlight"
                  className="white linkhoverW mbfs-14"
                >
                  Create Highlight
                </Link>
              </Button>
            )}
          </div>
        </div>
        <div className="clear30"></div>
        <div className="row">
          {getAllHighlight &&
            getAllHighlight.map((item, index) => (
              <div key={index} className="col-lg-4 col-md-4 col-12 plr">
                <Card id="Card_Hlight">
                  <ReactPlayer
                    id="videoPlayer"
                    url={item.videoUrl}
                    playing={false}
                    controls
                    onClick={() => highlighsViewsCountApi(item.id)}
                  />
                  <Card.Body>
                    <Card.Title className="fs-24 medium mbfs24">
                      {item.videoName}
                    </Card.Title>
                    <Card.Text>
                      <div className="row">
                        <div className="col-lg-4">
                          <label className="fs-20 medium opacity07 mbfs20">
                            {item.viewCount} View
                          </label>
                        </div>
                        <div className="col-lg-8">
                          <label className="fs-20 medium opacity07">
                            {moment(item.createdAt).format("MM/DD/YYYY")}
                          </label>
                        </div>
                      </div>
                    </Card.Text>
                  </Card.Body>
                  <Card.Footer>
                    {adminRole != "ATHLETE" && (
                      <div className="row">
                        <div className="col-4 col-lg-4 border-right text-center">
                          <label
                            className="fs-20 medium mb-0 cp"
                            onClick={() => {
                              selectedShareVideo(item.videoUrl, item.id);
                            }}
                          >
                            Share
                          </label>
                        </div>
                        <div className="col-4 col-lg-4 border-right text-center">
                          <Link to="/pdftronHighlightEdit">
                            <label
                              className="fs-20 medium mb-0 cp"
                              onClick={() => {
                                selectedEdit(item.videoUrl, item.id);
                              }}
                            >
                              Edit
                            </label>
                          </Link>
                        </div>
                        <div
                          className="col-4 col-lg-4 text-center"
                          id="dotDROPDOWN"
                        >
                          <div class="dropdown">
                            <span className="cp">
                              <img
                                className="cp"
                                src={threedotIMG}
                                alt="menu"
                              ></img>
                            </span>
                            <div class="dropdown-content">
                              {/* { allSchoolList && allSchoolList.map((item, index) => (   */}
                              <div className="row">
                                <img
                                  src={sndHighlite}
                                  alt=""
                                  className="shareICON"
                                ></img>
                                <span
                                  className="cp fs-14 regular pl-2"
                                  onClick={() => {
                                    openHighlightSendRequest(item.id);
                                  }}
                                >
                                  <label className="cp">
                                    Send Highlight request
                                  </label>
                                </span>
                                <div className="clear"></div>
                              </div>

                              <div className="clear"></div>
                              <div className="row">
                                <img
                                  src={Delete}
                                  alt="share"
                                  className="delicon-new"
                                ></img>
                                <label
                                  className="cp fs-14 regular pl-2 pt-1 txtred"
                                  onClick={() => openDialog(item.id)}
                                >
                                  Delete
                                </label>
                                <div className="clear"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Card.Footer>
                </Card>
              </div>
            ))}
        </div>

        <div className="clear30"></div>
        <div className="row"></div>

        {/* end */}

        {/* ALL MODALS HERE */}
        <Dialog id="dialogBox" open={opens} onClose={closeDialog}>
          <DialogTitle>
            <div className="row">
              <div className="col-1 text-right ml-auto ">
                <img
                  onClick={closeDialog}
                  className="crossview cp"
                  alt="close"
                  src={close}
                ></img>
              </div>
            </div>
          </DialogTitle>
          <DialogContent>
            <div className="clear10"></div>
            <div className="row">
              <div className="col-12 text-center">
                <p className="fs-20 semi-bold text-center mb-4">
                  Are you sure
                  <br />
                  you want to remove the record?
                </p>
              </div>
              <div className="col-5 col-md-3 col-lg-3 ml-auto text-center">
                <button type="button" class="cancelbtn" onClick={closeDialog}>
                  No
                </button>
              </div>
              <div className="col-5 col-md-3 col-lg-3 mr-auto text-center ">
                <button
                  type="button"
                  class="yes-btn"
                  onClick={ConfirmcloseDialog}
                >
                  Yes, Remove
                </button>
                {/* </Link> */}
              </div>
            </div>
            <div className="clear10"></div>
            <div className="clear10"></div>
          </DialogContent>
        </Dialog>

        <Dialog
          id="dialogBoxRemove"
          className="dialog-style"
          open={popSuccess}
          onClose={closeDialogRemoved}
        >
          <DialogTitle>
            <div className="row">
              <div className="col-1 text-right ml-auto">
                <img
                  onClick={closeDialogRemoved}
                  className="crossview cp"
                  alt="close"
                  src={close}
                ></img>
              </div>
            </div>
          </DialogTitle>
          <DialogContent>
            <div className="clear10"></div>
            <div className="row">
              <div className="col-12 text-center">
                <img
                  src={successimg}
                  alt="success"
                  className="successimg-new"
                ></img>
                <p className="fs-20 semi-bold text-center">
                  Highlight Removed Successfully!
                </p>
                <div className="clear10"></div>
              </div>
              <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                <button
                  type="button"
                  class="donebtn"
                  onClick={closeDialogRemoved}
                >
                  DONE
                </button>
              </div>
            </div>

            <div className="clear10"></div>

            <div className="clear10"></div>
          </DialogContent>
        </Dialog>

        {/* DELETE POP UP */}
        <Dialog open={opendel} onClose={handleToDel} id="DeleteSchoolPopup">
          <DialogTitle>
            <div className="row">
              <div className="col-11 col-lg-11 col-md-11 text-center">
                <label className="fs-18 semibold">Are You Sure?</label>
              </div>
              <div className="col-1 text-right ml-auto">
                <img
                  alt=""
                  src={crosstick}
                  onClick={handleToDel}
                  className="cp"
                />
              </div>
            </div>
          </DialogTitle>
          <hr className="mt-0 mb-0"></hr>
          <DialogContent className="text-center">
            <DialogContentText>
              <label className="fs-16 semibold mb-0 mt-3">
                Clicking on “Delete” will remove this clip
              </label>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="d-block">
            <div className="row text-center">
              <div className="col-lg-6 text-right">
                <button
                  type="button"
                  className="cancelbtn mr-2"
                  onClick={handleToDel}
                >
                  CANCEL
                </button>
              </div>
              <div className="col-lg-6 text-left">
                <button
                  type="submit"
                  className="DeleteBTN"
                  onClick={handleToDelSuccess}
                >
                  Delete
                </button>
              </div>
            </div>
          </DialogActions>
          <div className="clear20"></div>
        </Dialog>

        {/* Deleced Sucessfully */}
        <Dialog
          id="dialogBoxRemove"
          className="dialog-style"
          open={opendelSuccess}
          onClose={handleToDelSuccess}
        >
          <DialogTitle>
            <div className="row">
              <div className="col-1 text-right ml-auto ">
                <img
                  onClick={handleCloseToDelSuccess}
                  className="crossview cp"
                  alt="close"
                  src={crosstick}
                ></img>
              </div>
            </div>
          </DialogTitle>
        </Dialog>
        {/* END MODALS */}

        {/* SHARE TO ATLETE AND COACHES MODAL */}
        <Modal
          show={showAtheleteModal}
          onHide={() => {
            handleModelone();
          }}
        >
          <Modal.Header>
            <div className="d-flex justify-content-between w-100">
              <h6 className="fs-20 semi-bold">Choose Option</h6>
              <BsXLg
                onClick={() => this.handleModelone()}
                className="crossview cp"
              ></BsXLg>
            </div>
          </Modal.Header>

          <Modal.Body>
            <div className="scroo-bar">
              <div className="row">
                <div className="col-lg-6 pr-2">
                  <h1 className="headcoach">Coaches</h1>
                  <p className="subtextnew">
                    Select Coaches to add them to your team.
                  </p>
                  <div className="clear20"></div>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="basic-addon1">
                        <img src={greySearch} alt="srch" />
                      </span>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search"
                      aria-label="Search"
                      aria-describedby="basic-addon1"
                    />
                  </div>
                  <div className="listBox">
                    {coachesDataTest &&
                      coachesDataTest.map((item, index) => (
                        <div class="checkbox">
                          <input
                            type="checkbox"
                            id={item.id}
                            onClick={(e) => coachesForFeed(item.id, e, index)}
                          />
                          <label for={item.id}>
                            <span>{item.fullName}</span>
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
                <div className="col-lg-6 pl-2">
                  <h1 className="headcoach">Athletes</h1>
                  <p className="subtextnew">
                    Select Athlete to add them to your team.
                  </p>
                  <div className="clear20"></div>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="basic-addon1">
                        <img src={greySearch} alt="srch" />
                      </span>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search"
                      aria-label="Search"
                      aria-describedby="basic-addon1"
                    />
                  </div>
                  <div className="listBox">
                    {atheleteDataTest &&
                      atheleteDataTest.map((item, index) => (
                        <div class="checkbox">
                          <input
                            type="checkbox"
                            id={item.id}
                            onClick={(e) => athleteForFeed(item.id, e, index)}
                          />
                          <label for={item.id}>
                            <span>{item.fullName}</span>
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="cancelbtn mr-2"
              onClick={() => {
                handleModelone();
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="savebtn"
              onClick={() => {
                handleModelfour();
              }}
            >
              Save
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showShareModal}
          onHide={() => {
            handleModelfive();
          }}
        >
          <Modal.Header>
            <div className="d-flex justify-content-between w-100">
              <h6 className="fs-20 semi-bold black">Share</h6>
              <BsXLg
                onClick={() => this.handleModelfive()}
                className="crossview cp"
              ></BsXLg>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-4 col-lg-4">
                <select
                  class="form-control fs-16 regular dblack olnone brdrtwenty shareselect"
                  onClick={() => {
                    onTypeOpen();
                  }}
                  id="sel1"
                >
                  <option>{showNameSelectFeed}</option>
                </select>
              </div>
            </div>
            <div className="clear20"></div>
            <div className="col-md-12 col-lg-12">
              <input
                type="text"
                className="inst fs-16 regular w-100 olnone"
                placeholder="Video Title in max 20 words here."
                value={videoTitle}
                onChange={(e) => test(e.target.value)}
              ></input>
            </div>
            <div className="clear20"></div>
            <div className="col-md-12 col-lg-12">
              <textarea
                type="text"
                rows="3"
                className="instn fs-16 regular w-100 olnone"
                placeholder="Video Description in max 20 words here."
                value={videoDescription}
                onChange={(e) => test1(e.target.value)}
              ></textarea>
            </div>
            <div className="clear20"></div>
            <div className="col-md-12 col-lg-12 h375">{AppSharePopUp()}</div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="fs-16 regular"
              onClick={() => {
                callPostForFeed();
              }}
            >
              Post
            </Button>
          </Modal.Footer>
        </Modal>
        {/* END MODAL */}

        {/* school remove pop up */}
        <Dialog
          id="dialogBoxRemove"
          className="dialog-style"
          open={openDialogShare}
          onClose={closeDialogShare.bind(this)}
        >
          <DialogTitle>
            <div className="row">
              <div className="col-1 text-right ml-auto mr-4">
                <img
                  onClick={closeDialogShare.bind(this)}
                  className="crossview cp"
                  alt="close"
                  src={close}
                ></img>
              </div>
            </div>
          </DialogTitle>
          <DialogContent>
            <div className="clear10"></div>
            <div className="row">
              <div className="col-12 text-center">
                <img
                  src={successimg}
                  alt="success"
                  className="successimg-new"
                ></img>
                <div className="clear20"></div>
                <p className="fs-20 semi-bold text-center">
                  Video shared successfully
                </p>
                <div className="clear30"></div>
              </div>
              <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                {/* <Link to={`/videoplayer/${this.state.eventId}`}> */}
                <button
                  type="button"
                  class="donebtn"
                  onClick={closeDialogShare.bind(this)}
                >
                  OK
                </button>
                {/* </Link> */}
              </div>
            </div>

            <div className="clear10"></div>

            <div className="clear10"></div>
          </DialogContent>
        </Dialog>
        {/* end  */}

        <Modal
          id="mwidth"
          show={showfive}
          onHide={() => {
            handleModelfive1();
          }}
        >
          <Modal.Header>
            <div className="d-flex justify-content-between w-100">
              <h6 className="fs-20 semi-bold black">Choose Option</h6>
              <BsXLg
                onClick={() => this.handleModelfive1()}
                className="crossview cp"
              ></BsXLg>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div id="cradio" className="col-md-12 col-lg-12">
                <label class="container fs-18 regular dblack">
                  <input
                    type="radio"
                    name="radio"
                    value="1"
                    onChange={handleRadioChange}
                  />
                  <span class="checkmark"></span>
                  Share on Feed
                </label>
              </div>
              <div className="col-md-12 col-lg-12">
                <hr className="p-0 m-0" />
              </div>
            </div>
            <div className="clear20"></div>
            <div className="row">
              <div id="cradio" className="col-md-12 col-lg-12">
                <label class="container fs-18 regular dblack">
                  <input
                    type="radio"
                    name="radio"
                    value="2"
                    onChange={handleRadioChange}
                  />
                  <span class="checkmark"></span>
                  Share to a groups
                </label>
              </div>
              <div className="col-md-12 col-lg-12">
                <hr className="p-0 m-0" />
              </div>
            </div>
            <div className="clear20"></div>
            <div className="row">
              <div id="cradio" className="col-md-12 col-lg-12">
                <label class="container fs-18 regular dblack">
                  <input
                    type="radio"
                    name="radio"
                    value="3"
                    onChange={handleRadioChange}
                    // onClick={() => {
                    //  this.handleModelAthelete();
                    // }}
                  />
                  <span class="checkmark"></span>
                  Share to Athletes / Coaches
                </label>
              </div>
              <div className="col-md-12 col-lg-12">
                <hr className="p-0 m-0" />
              </div>
            </div>
            <div className="clear20"></div>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="cancelbtn mr-2">
              Cancel
            </button>
            <button
              type="submit"
              className="savebtn"
              onClick={() => {
                handleModelfive1();
              }}
            >
              Save
            </button>
            {/* <Button className="fs-16 regular" onClick={() => { this.handleModelfive() }}>
              Post
              </Button> */}
          </Modal.Footer>
        </Modal>

        <Modal
          id="heighlightMM"
          show={sendHighlightRequest}
          onHide={() => {
            closeHighlightSendRequest();
          }}
        >
          <Modal.Header>
            <div className="d-flex justify-content-between w-100">
              <h6 className="fs-20 semi-bold black">Send Highlight request</h6>
              <BsXLg
                onClick={() => this.closeHighlightSendRequest()}
                className="crossview cp"
              ></BsXLg>
            </div>
          </Modal.Header>
          <Modal.Body>
            <p className="fs-18 sendhighlighttext">
              Are you sure you want to send this video to feature on ContendZone
              Highlights?
            </p>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="cancelbtn mr-2"
              onClick={() => {
                closeHighlightSendRequest();
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="savebtn"
              onClick={() => {
                callHighlightSend();
              }}
            >
              Send
            </button>
          </Modal.Footer>
        </Modal>

        {/* school remove pop up */}
        <Dialog
          id="dialogBoxRemove"
          className="dialog-style"
          open={openDialogHighlightRequest}
          onClose={closeDialogHighlightRequest.bind(this)}
        >
          <DialogTitle>
            <div className="row">
              <div className="col-1 text-right ml-auto mr-4">
                <img
                  onClick={closeDialogHighlightRequest.bind(this)}
                  className="crossview cp"
                  alt="close"
                  src={close}
                ></img>
              </div>
            </div>
          </DialogTitle>
          <DialogContent>
            <div className="clear10"></div>
            <div className="row">
              <div className="col-12 text-center">
                <img
                  src={successimg}
                  alt="success"
                  className="successimg-new"
                ></img>
                <div className="clear20"></div>
                <p className="fs-20 semi-bold text-center">
                  Highlight request sent successfully
                </p>
                <div className="clear30"></div>
              </div>
              <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                {/* <Link to={`/videoplayer/${this.state.eventId}`}> */}
                <button
                  type="button"
                  class="donebtn"
                  onClick={closeDialogHighlightRequest.bind(this)}
                >
                  OK
                </button>
                {/* </Link> */}
              </div>
            </div>

            <div className="clear10"></div>

            <div className="clear10"></div>
          </DialogContent>
        </Dialog>
        {/* end  */}

        {/* <Snackbar
     id="snackbar"
     anchorOrigin={{
      vertical: "top",
      horizontal: "right",
     }}
     open={openHighlightSuccess}
     autoHideDuration={1500}
     onClose={closeHighlightSuccessMsg()}
     ContentProps={{
      "aria-describedby": "message-id",
     }}
     message={<span id="message-id">Request successfully sent.</span>}
     action={[]}
    /> */}
      </div>
    </div>
  );
}

export default SchoolHighlights;
